import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { useHistoryMovementsView } from '../context/HistoryMovementsViewContext';

const HistoryMovementsViewCollapsedTableHeader: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useHistoryMovementsView();

  const historyMovementsLength = data?.historyMovements?.length || 0;

  return (
    <thead>
      <tr className="tb-tnx-head">
        <th className="text-left" colSpan={2}>
          <span>
            {t('Movements')} ({historyMovementsLength})
          </span>
        </th>
        <th className="col-2 text-right">
          <button
            type="button"
            className="badge btn-primary"
            onClick={actions.handleChangeExpandView}
          >
            <em className={`icon ni ni-chevron-${data.expandDirection}`} />
          </button>
        </th>
      </tr>
    </thead>
  );
};

export default HistoryMovementsViewCollapsedTableHeader;
